export const LOCAL_FILTER_FIELDS = [
    {
        label: "Code",
        type: "text",
        name: "supplierGroupCode",
    },
    {
        label: "Name",
        type: "text",
        name: "supplierGroupName",
    }
]